<template>
  <div>
    <el-card  :class="{ 'hide-body': !showFilters }">
      <div slot="header" class="d-flex space-between">
        <h3>Reporte de Herramienta de trabajo</h3>
        <el-button size="mini" plain @click="showFilters = !showFilters">
          <i v-if="!showFilters" class="icon el-icon-arrow-down "></i>
          <i v-if="showFilters" class="icon el-icon-arrow-up "></i>
        </el-button>
      </div>
      <el-row :gutter="10" v-if="showFilters">
        <el-col :md="12">
          <el-select v-model="filters.payroll_id"
                     @change="onChangeOption()"
                     placeholder="Seleccionar Planilla"
                     style="width: 100%">
            <el-option
              v-for="item in payrolls"
              :key="item.id"
              :label="item.name"
              :value="item.id">
              <span style="float: left">{{ item.name }}</span>
              <span style="float: right; color: #8492a6; font-size: 13px">{{ item.type }}</span>
            </el-option>
          </el-select>
        </el-col>
        <el-col :md="12">
          <el-select v-model="filters.report"
                     :placeholder="loadingReports ? 'Cargando...' : 'Seleccionar Periodo'"
                     style="width: 100%">
            <el-option
              v-for="item in reportDates"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-col>
      </el-row>
      <el-row :gutter="10" style="margin-top: 20px">
        <el-col :md="12">
            <el-input placeholder="# Envio" v-model="filters.envio"
                             :min="0"
                             label="Envio"
                             style="width: 100%;">
            </el-input>
        </el-col>
        <el-col :md="12">
          <el-input placeholder="Concepto" v-model="filters.concept"
                    :min="0"
                    label="Concepto"
                    style="width: 100%;">
          </el-input>
        </el-col>
      </el-row>
      <el-row :gutter="10" style="margin-top: 20px" v-if="showFilters">
        <el-col :md="24">
          <el-button type="primary" :disabled="!validForm()" @click="loadReports()" :loading="loading" plain>Cargar Datos</el-button>
          <el-button type="success" :disabled="!validForm()" @click="exportReport()" :loading="exporting" plain>Exportar</el-button>
          <el-dropdown @command="handleCommand">
            <el-button type="danger" :disabled="!validForm()">
              Exportar BAC<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown" >
              <el-dropdown-item command="a" :loading="exporting" >PRN</el-dropdown-item>
              <el-dropdown-item command="b" :loading="exporting" >Excel</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-dropdown @command="handleCommand">
            <el-button type="primary" :disabled="!validForm()">
              Exportar Nacional<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown" >
              <el-dropdown-item command="c" :loading="exporting" >ENV</el-dropdown-item>
              <el-dropdown-item command="d" :loading="exporting" >Excel</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-button type="warning" :disabled="!validForm()" @click="exportOtherXLS()" :loading="exporting" plain>Otros Bancos</el-button>
        </el-col>
      </el-row>
    </el-card>
    <el-card class="card-table" v-loading="loading">
      <HotTable :root="root" :settings="tableSettings"></HotTable>
    </el-card>

  </div>
</template>
<script>
  import HotTable from '@handsontable/vue'
  import {baseApi} from '../../configs/urls'
  import {params, parseError} from '../../packages/Helpers'
  import {saveAs} from 'file-saver'
  export default {
    name: 'liquidation-report',
    components: {
      HotTable
    },
    data () {
      return {
        root: 'test-hot',
        showFilters: true,
        tableSettings: {
          data: [],
          columns: [],
          colHeaders: [],
          fixedColumnsLeft: 3,
          height: 600,
          manualColumnFreeze: true,
          allowInsertColumn: false,
          allowInsertRow: false
        },
        exporting: false,
        columnsMeta: [],
        loadingPayRolls: false,
        payrolls: [],
        filters: {},
        loadingReports: false,
        reportDates: [],
        loading: false
      }
    },
    methods: {
      handleCommand (command) {
        console.log(command)
        switch (command) {
          case 'a': this.exportPRN()
            break
          case 'b': this.exportPRNXLS()
            break
          case 'c': this.exportENV()
            break
          case 'd': this.exportENVXLS()
            break
        }
      },
      validForm () {
        if (this.filters.payroll_id && this.filters.report) {
          return true
        }
        return false
      },
      getBaseData () {
        let data = {
          payroll_id: this.filters.payroll_id
        }

        let result = this.reportDates.filter((item) => {
          return item.value === this.filters.report
        })
        if (result.length > 0) {
          data.init_date = result[0].init_date
          data.end_date = result[0].end_date
        }
        return data
      },
      getPRNData () {
        let data = {
          payroll_id: this.filters.payroll_id
        }

        let result = this.reportDates.filter((item) => {
          return item.value === this.filters.report
        })
        if (result.length > 0) {
          data.init_date = result[0].init_date
          data.end_date = result[0].end_date
        }
        data.envio = this.filters.envio
        data.concept = this.filters.concept
        return data
      },
      onChangeOption () {
        if (this.filters.payroll_id) {
          this.reportDates = []
          this.loadingReports = true
          const data = {
            payroll_id: this.filters.payroll_id,
            confirmed: true
          }
          this.$http.get(baseApi + '/transportreports' + params(data))
            .then(
              (response) => {
                this.reportDates = response.body
                this.loadingReports = false
              },
              (res) => {
                this.$message.error(parseError(res)[0])
                this.loadingReports = false
              }
            )
        }
      },
      loadReports () {
        if (!this.validForm()) {
          this.$message.error('Verifica que esten todos los campos llenos.')
          return
        }

        const data = this.getBaseData()

        this.tableSettings.data = []
        this.loading = true
        this.$http.get(baseApi + '/transportreports/confirmed' + params(data))
          .then(
            (response) => {
              const data = response.body
              const params = data.params
              this.columnsMeta = params

              this.columnsMeta = Object.keys(params).map((param) => {
                let output = Object.assign({}, params[param])
                output.key = param
                return output
              })

              let columns = []
              let headers = data.headers
              if (data.data.length > 0) {
                columns = headers.map((key) => {
                  let output = {
                    data: key.replace(/ /g, '_'),
                    readOnly: true
                  }

                  let result = null
                  for (let index in params) {
                    if (index && params.hasOwnProperty(index) && index === output.data && params[index].formula) {
                      result = params[index]
                      break
                    }
                  }

                  if (result) {
                    output.type = 'numeric'
                    output.numericFormat = {
                      pattern: '0.00'
                    }
                  }

                  return output
                })
              }

              this.tableSettings.data = data.data
              this.tableSettings.columns = columns
              this.tableSettings.colHeaders = headers
              this.loading = false
            },
            (res) => {
              this.$message.error(parseError(res)[0])
              this.loading = false
            }
          )
      },
      exportReport () {
        const data = this.getBaseData()
        let url = baseApi + '/transportreports/excel' + params(data)
        this.exporting = true
        this.$http.post(url, {}, {
          responseType: 'arraybuffer',
          headers: {'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}
        })
        .then(
          (response) => {
            const blob = new Blob([response.data], {type: 'application/octet-stream'})
            const payrolls = this.payrolls.filter((item) => {
              return item.id === this.filters.payroll_id
            })
            let filename = 'nomina '

            if (payrolls.length > 0) {
              filename += payrolls[0]['name'] + ' '
            }

            filename += data.init_date + ' ' + data.end_date
            saveAs(blob, filename + '.xlsx')
            this.exporting = false
          },
          (res) => {
            this.$message.error(parseError(res)[0])
            this.exporting = false
          }
        )
      },
      exportPRN () {
        const data = this.getPRNData()
        let url = baseApi + '/transportreports/prn' + params(data)
        this.exporting = true
        this.$http.post(url, {}, {
          responseType: 'arraybuffer',
          headers: {'Accept': 'text/plain'}
        })
          .then(
            (response) => {
              const blob = new Blob([response.data], {type: 'text/plain'})
              const payrolls = this.payrolls.filter((item) => {
                return item.id === this.filters.payroll_id
              })
              let filename = 'nomina '

              if (payrolls.length > 0) {
                filename += payrolls[0]['name'] + ' '
              }

              filename += data.init_date + ' ' + data.end_date
              saveAs(blob, filename + '.PRN')
              this.exporting = false
            },
            (res) => {
              this.$message.error(parseError(res)[0])
              this.exporting = false
            }
          )
      },
      showTestKey (testKey) {
        this.$alert(`Se ha generado el archivo, para la confirmación necesitara el <br/><big><b> Test Key ${testKey}</b></big><br/>favor tomar nota de este codigo`, 'BTL VISOR', {
          confirmButtonText: 'Aceptar',
          dangerouslyUseHTMLString: true
        })
      },
      exportPRNXLS () {
        const data = this.getPRNData()
        let url = baseApi + '/transportreports/prne' + params(data)
        this.exporting = true
        this.$http.post(url, {}, {
          responseType: 'arraybuffer',
          headers: {'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}
        })
          .then(
            (response) => {
              const blob = new Blob([response.data], {type: 'application/octet-stream'})
              const payrolls = this.payrolls.filter((item) => {
                return item.id === this.filters.payroll_id
              })
              let filename = 'nomina '

              if (payrolls.length > 0) {
                filename += payrolls[0]['name'] + ' '
              }

              filename += data.init_date + ' ' + data.end_date
              saveAs(blob, filename + '.xlsx')
              this.exporting = false
            },
            (res) => {
              this.$message.error(parseError(res)[0])
              this.exporting = false
            }
          )
      },
      exportENV () {
        const data = this.getPRNData()
        let url = baseApi + '/transportreports/env' + params(data)
        this.exporting = true
        this.$http.post(url, {}, {
          headers: {'Accept': 'text/plain'}
        })
          .then(
            (response) => {
              const blob = new Blob([response.data.content], {type: 'application/octet-stream'})
              const payrolls = this.payrolls.filter((item) => {
                return item.id === this.filters.payroll_id
              })
              let filename = 'nomina '

              if (payrolls.length > 0) {
                filename += payrolls[0]['name'] + ' '
              }

              filename += data.init_date + ' ' + data.end_date
              saveAs(blob, filename + '.env')
              this.showTestKey(response.data.testKey)
              this.exporting = false
            },
            (res) => {
              this.$message.error(parseError(res)[0])
              this.exporting = false
            }
          )
      },
      exportENVXLS () {
        const data = this.getPRNData()
        let url = baseApi + '/transportreports/enve' + params(data)
        this.exporting = true
        this.$http.post(url, {}, {
          responseType: 'arraybuffer',
          headers: {'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}
        })
          .then(
            (response) => {
              const blob = new Blob([response.data], {type: 'application/octet-stream'})
              const payrolls = this.payrolls.filter((item) => {
                return item.id === this.filters.payroll_id
              })
              let filename = 'nomina BNCR'

              if (payrolls.length > 0) {
                filename += payrolls[0]['name'] + ' '
              }

              filename += data.init_date + ' ' + data.end_date
              saveAs(blob, filename + '.xlsx')
              this.exporting = false
            },
            (res) => {
              this.$message.error(parseError(res)[0])
              this.exporting = false
            }
          )
      },
      exportOtherXLS () {
        const data = this.getPRNData()
        let url = baseApi + '/transportreports/other' + params(data)
        this.exporting = true
        this.$http.post(url, {}, {
          responseType: 'arraybuffer',
          headers: {'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}
        })
          .then(
            (response) => {
              const blob = new Blob([response.data], {type: 'application/octet-stream'})
              const payrolls = this.payrolls.filter((item) => {
                return item.id === this.filters.payroll_id
              })
              let filename = 'nominaOtrosBancos'

              if (payrolls.length > 0) {
                filename += payrolls[0]['name'] + ' '
              }

              filename += data.init_date + ' ' + data.end_date
              saveAs(blob, filename + '.xlsx')
              this.exporting = false
            },
            (res) => {
              this.$message.error(parseError(res)[0])
              this.exporting = false
            }
          )
      }
    },
    mounted () {
      this.loadingPayRolls = true
      this.$http.get(baseApi + '/payrolls')
        .then(
          (response) => {
            this.payrolls = response.body
            this.loadingPayRolls = false
          },
          (res) => {
            this.$message.error(parseError(res)[0])
            this.loadingPayRolls = false
          }
        )
    }
  }
</script>
<style>
  .el-card {
    margin-top: 30px
  }

  .el-card:last-child {
    margin-bottom: 100px
  }

  h3 {
    margin: 0
  }

  #test-hot td {
    padding-top: 10px;
    padding-bottom: 10px;
  }
  #test-hot .ht_clone_left td,
  #test-hot .ht_clone_top_left_corner td {
    height: auto !important;
  }
</style>
<style src="handsontable/dist/handsontable.full.css"></style>



// WEBPACK FOOTER //
// src/views/reports/TransportReport.vue